module.exports = __webpack_public_path__ + "static/img/200170.8738f1e0.png";